import { QuoteStatus, QuoteStatusTypes } from "./quote-response";

function resolveStatusColor(type) {
    switch (type) {
        case QuoteStatusTypes.REJECTED:
            return "red";
        case QuoteStatusTypes.PENDING:
            return "dark-blue";
        case QuoteStatusTypes.COMPLETED:
            return "green";
        default:
            return "dark-blue";
    }
}

const getStatusText = ({ type, text }: QuoteStatus): string => {
    const statusColor = resolveStatusColor(type);
    return `<span class="ux-text-status ux-text-status--${statusColor}">${text}</span>`;
};

export default getStatusText;
